import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import DeploymentToProjectTaskRedirect from "./DeploymentToProjectTaskRedirect";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";

export default class DeploymentRoutes extends React.Component<RouteComponentProps<any>, any> {
    render() {
        const match = this.props.match;
        return (
            <Switch>
                <ReloadableRoute path={`${match.url}/:deploymentId`} component={DeploymentToProjectTaskRedirect} />
            </Switch>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/deployments/DeploymentRoutes.tsx